import { IViewFiltersData } from '@api'
import css from './index.module.scss'
import { Icon } from '@runeffective/evo-design-system'
import { Tooltip2 } from '@blueprintjs/popover2'
import { Position } from '@blueprintjs/core'
import { GeneralFilters, getFilterNameByID } from './viewFiltersCalculations'

type ChildFiltersProps = {
  viewFiltersData: IViewFiltersData
  id: string
  mapViewSetting?: any
}

enum ToggleKeys {
  ON = 'On',
  OFF = 'Off',
  HIDE = 'hide',
  SHOW = 'show',
}

const ChildFilters = ({
  viewFiltersData: { getFilterById, toggleChild },
  id,
  mapViewSetting,
}: ChildFiltersProps) => {
  const { tooltip, visible, name, disableOnPrimary } = getFilterById(id)
  const getTooltip = () => {
    if (tooltip) return tooltip
    if (!name) return
    return `${visible ? ToggleKeys.HIDE : ToggleKeys.SHOW} ${name.toLowerCase()}`
  }

  const toggleFilter = (id: string) => {
    mapViewSetting?.updateMapViewSettings(
      getFilterNameByID(id),
      visible ? ToggleKeys.OFF : ToggleKeys.ON,
      [
        GeneralFilters.DEPARTMENT,
        GeneralFilters.NEIGHBORHOODS,
        GeneralFilters.WORKPLACE_GROUP,
        GeneralFilters.TEAM,
        GeneralFilters.SEAT_WORKPLACE_GROUP,
      ]
    )
    toggleChild(id)
  }

  return (
    <div
      className={css.childFilterWrapper}
      style={disableOnPrimary ? { pointerEvents: 'none', opacity: 0.5 } : undefined}
      onClick={() => toggleFilter(id)}
      key={id}>
      <div className={css.childFilterName} title={name}>
        {name}
      </div>
      <Tooltip2 content={getTooltip()} placement={Position.LEFT}>
        {visible ? (
          <Icon iconName={'fa-thin fa-eye'} iconStyle="fal" size="sm" />
        ) : (
          <Icon iconName={'fa-thin fa-eye-slash'} iconStyle="fal" size="sm" />
        )}
      </Tooltip2>
    </div>
  )
}
export default ChildFilters
